// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { useLocalMessage } from '@Helpers/locale';
import { Alert } from 'antd';
import React, { ReactElement } from 'react';

import './UnavailableMessage.scss';

interface UnavailableMessageProps {
    type?: 'module' | 'capability';
    full?: boolean;
}

export const UnavailableMessage = ({ full = false, type = 'module' }: UnavailableMessageProps): ReactElement => {
    const local = useLocalMessage();

    return (
        <div
            className={classList('unavailable-message-layout__disabled', {
                full,
            })}
        >
            {type === 'module' ? (
                <Alert
                    message={local('configPlateform.unavailable.message')}
                    description={local('configPlateform.unavailable.description')}
                    type="warning"
                />
            ) : (
                <div className="unavailable-message-capability">
                    <p className="unavailable-message-capability__message">
                        {local('configPlateform.unavailable.message')}
                    </p>
                </div>
            )}
        </div>
    );
};
